import { render, staticRenderFns } from "./OrgaosCaptadosForm.vue?vue&type=template&id=ff4a0f7a&scoped=true&"
import script from "./OrgaosCaptadosForm.vue?vue&type=script&lang=js&"
export * from "./OrgaosCaptadosForm.vue?vue&type=script&lang=js&"
import style0 from "./OrgaosCaptadosForm.vue?vue&type=style&index=0&id=ff4a0f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4a0f7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCardText,VCol,VForm,VRadio,VRadioGroup,VRow,VSelect,VTextField})
